var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c(
      "div",
      {
        staticStyle: {
          "max-width": "850px",
          margin: "0px auto",
          "margin-top": "20px"
        }
      },
      [
        _vm._m(0),
        _c("div", { staticClass: "columns" }, [
          _vm._m(1),
          _c("div", { staticClass: "column" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.projectName,
                  expression: "user.projectName"
                }
              ],
              staticClass: "input",
              attrs: {
                placeholder: "ชื่อโปรเจค",
                type: "text",
                name: "projectName",
                id: "projectName",
                required: ""
              },
              domProps: { value: _vm.user.projectName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.user, "projectName", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _vm._m(2),
          _c("div", { staticClass: "column " }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.partName,
                  expression: "user.partName"
                }
              ],
              staticClass: "input",
              attrs: {
                placeholder: "ชื่อพาร์ท",
                type: "text",
                name: "partName",
                id: "partName",
                required: ""
              },
              domProps: { value: _vm.user.partName },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.user, "partName", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _vm._m(3),
          _c("div", { staticClass: "column " }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.partNumber,
                  expression: "user.partNumber"
                }
              ],
              staticClass: "input",
              attrs: {
                placeholder: "เลขพาร์ท",
                type: "text",
                name: "partNumber",
                id: "partNumber",
                required: ""
              },
              domProps: { value: _vm.user.partNumber },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.user, "partNumber", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _vm._m(4),
          _c("div", { staticClass: "column " }, [
            !_vm.productTypeCustom
              ? _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.typeOfProduct,
                          expression: "user.typeOfProduct"
                        }
                      ],
                      attrs: {
                        name: "typeOfProduct",
                        id: "typeOfProduct",
                        required: ""
                      },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.user,
                              "typeOfProduct",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          function($event) {
                            _vm.selectETC()
                          }
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "", disabled: "" } }, [
                        _vm._v("ประเภทสินค้า")
                      ]),
                      _vm._l(this.typeOfProduct, function(item, index) {
                        return _c(
                          "option",
                          { key: index, domProps: { value: item } },
                          [_vm._v(_vm._s(item))]
                        )
                      })
                    ],
                    2
                  )
                ])
              : _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.typeOfProduct,
                        expression: "user.typeOfProduct"
                      }
                    ],
                    staticClass: "input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.user.typeOfProduct },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "typeOfProduct", $event.target.value)
                      }
                    }
                  }),
                  _c(
                    "p",
                    {
                      staticClass: "is-link",
                      on: {
                        click: function($event) {
                          _vm.clearTypeOfProduct()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-times" }), _vm._v(" clear")]
                  )
                ])
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _vm._m(5),
          _c("div", { staticClass: "column" }, [
            !_vm.materialCustomer
              ? _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.material,
                          expression: "user.material"
                        }
                      ],
                      attrs: { name: "materail", id: "material", required: "" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.user,
                              "material",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.selectMaterial
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "", disabled: "" } }, [
                        _vm._v("วัสดุ")
                      ]),
                      _c(
                        "option",
                        { attrs: { value: "Carbo Steel", disabled: "" } },
                        [_vm._v("Carbon Steel")]
                      ),
                      _c("option", { attrs: { value: "SS400" } }, [
                        _vm._v("    SS400")
                      ]),
                      _c("option", { attrs: { value: "S45C" } }, [
                        _vm._v("    S45C")
                      ]),
                      _c("option", { attrs: { value: "S50C" } }, [
                        _vm._v("    S50C")
                      ]),
                      _c("option", { attrs: { value: "Etc." } }, [
                        _vm._v("    Etc")
                      ]),
                      _c("option", { attrs: { value: "SUS", disabled: "" } }, [
                        _vm._v("SUS >")
                      ]),
                      _c("option", { attrs: { value: "304" } }, [
                        _vm._v("    304")
                      ]),
                      _c("option", { attrs: { value: "304L" } }, [
                        _vm._v("    304L")
                      ]),
                      _c("option", { attrs: { value: "316" } }, [
                        _vm._v("    316")
                      ]),
                      _c("option", { attrs: { value: "316L" } }, [
                        _vm._v("    316L")
                      ]),
                      _c("option", { attrs: { value: "Etc." } }, [
                        _vm._v("    Etc")
                      ]),
                      _c("option", { attrs: { value: "Brass" } }, [
                        _vm._v("Brass")
                      ]),
                      _c("option", { attrs: { value: "Aluminium" } }, [
                        _vm._v("Aluminium")
                      ]),
                      _c("option", { attrs: { value: "Copper" } }, [
                        _vm._v("Copper")
                      ])
                    ]
                  )
                ])
              : _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.material,
                        expression: "user.material"
                      }
                    ],
                    staticClass: "input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.user.material },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "material", $event.target.value)
                      }
                    }
                  }),
                  _c(
                    "p",
                    {
                      staticClass: "is-link",
                      on: {
                        click: function($event) {
                          _vm.clearMaterial()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-times" }), _vm._v(" clear")]
                  )
                ])
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _vm._m(6),
          _c("div", { staticClass: "column " }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.hardening,
                  expression: "user.hardening"
                }
              ],
              staticClass: "input",
              attrs: {
                placeholder: "ความแข็ง",
                type: "text",
                name: "hardening",
                id: "hardening",
                required: ""
              },
              domProps: { value: _vm.user.hardening },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.user, "hardening", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _vm._m(7),
          _c("div", { staticClass: "column" }, [
            !_vm.platingCustom
              ? _c("div", { staticClass: "select" }, [
                  _c(
                    "select",
                    {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.user.plating,
                          expression: "user.plating"
                        }
                      ],
                      attrs: { name: "plating", id: "plating", required: "" },
                      on: {
                        change: [
                          function($event) {
                            var $$selectedVal = Array.prototype.filter
                              .call($event.target.options, function(o) {
                                return o.selected
                              })
                              .map(function(o) {
                                var val = "_value" in o ? o._value : o.value
                                return val
                              })
                            _vm.$set(
                              _vm.user,
                              "plating",
                              $event.target.multiple
                                ? $$selectedVal
                                : $$selectedVal[0]
                            )
                          },
                          _vm.selectPlating
                        ]
                      }
                    },
                    [
                      _c("option", { attrs: { value: "", disabled: "" } }, [
                        _vm._v("ชุบ")
                      ]),
                      _c("option", { attrs: { value: "Hardcrome" } }, [
                        _vm._v("Hardcrome")
                      ]),
                      _c("option", { attrs: { value: "Zinc" } }, [
                        _vm._v("Zinc")
                      ]),
                      _c("option", { attrs: { value: "ENP" } }, [
                        _vm._v("ENP")
                      ]),
                      _c("option", { attrs: { value: "Galvanizing" } }, [
                        _vm._v("Galvanizing")
                      ]),
                      _c("option", { attrs: { value: "Black Oxide" } }, [
                        _vm._v("Black Oxide")
                      ]),
                      _c("option", { attrs: { value: "Etc" } }, [_vm._v("Etc")])
                    ]
                  )
                ])
              : _c("div", [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.user.plating,
                        expression: "user.plating"
                      }
                    ],
                    staticClass: "input",
                    attrs: { type: "text" },
                    domProps: { value: _vm.user.plating },
                    on: {
                      input: function($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.$set(_vm.user, "plating", $event.target.value)
                      }
                    }
                  }),
                  _c(
                    "p",
                    {
                      staticClass: "is-link",
                      on: {
                        click: function($event) {
                          _vm.clearPlating()
                        }
                      }
                    },
                    [_c("i", { staticClass: "fa fa-times" }), _vm._v(" clear")]
                  )
                ])
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _vm._m(8),
          _c("div", { staticClass: "column" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.quantity,
                  expression: "user.quantity"
                }
              ],
              staticClass: "input",
              attrs: {
                placeholder: "จำนวน",
                type: "number",
                name: "quantity",
                id: "quantity",
                required: ""
              },
              domProps: { value: _vm.user.quantity },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.user, "quantity", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _vm._m(9),
          _c("div", { staticClass: "column" }, [
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.dataInspection,
                  expression: "user.dataInspection"
                }
              ],
              attrs: {
                type: "checkbox",
                name: "dataInspection",
                value: "Visual"
              },
              domProps: {
                checked: Array.isArray(_vm.user.dataInspection)
                  ? _vm._i(_vm.user.dataInspection, "Visual") > -1
                  : _vm.user.dataInspection
              },
              on: {
                change: function($event) {
                  var $$a = _vm.user.dataInspection,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = "Visual",
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.user.dataInspection = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.user.dataInspection = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.$set(_vm.user, "dataInspection", $$c)
                  }
                }
              }
            }),
            _vm._v(" Visual\n            "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.dataInspection,
                  expression: "user.dataInspection"
                }
              ],
              attrs: {
                type: "checkbox",
                name: "dataInspection",
                value: "Machine"
              },
              domProps: {
                checked: Array.isArray(_vm.user.dataInspection)
                  ? _vm._i(_vm.user.dataInspection, "Machine") > -1
                  : _vm.user.dataInspection
              },
              on: {
                change: function($event) {
                  var $$a = _vm.user.dataInspection,
                    $$el = $event.target,
                    $$c = $$el.checked ? true : false
                  if (Array.isArray($$a)) {
                    var $$v = "Machine",
                      $$i = _vm._i($$a, $$v)
                    if ($$el.checked) {
                      $$i < 0 && (_vm.user.dataInspection = $$a.concat([$$v]))
                    } else {
                      $$i > -1 &&
                        (_vm.user.dataInspection = $$a
                          .slice(0, $$i)
                          .concat($$a.slice($$i + 1)))
                    }
                  } else {
                    _vm.$set(_vm.user, "dataInspection", $$c)
                  }
                }
              }
            }),
            _vm._v(" Machine\n        ")
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _vm._m(10),
          _c("div", { staticClass: "column " }, [
            _c("textarea", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.user.description,
                  expression: "user.description"
                }
              ],
              staticClass: "textarea",
              attrs: { placeholder: "รายละเอียด", rows: "10" },
              domProps: { value: _vm.user.description },
              on: {
                input: function($event) {
                  if ($event.target.composing) {
                    return
                  }
                  _vm.$set(_vm.user, "description", $event.target.value)
                }
              }
            })
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _vm._m(11),
          _c(
            "div",
            { staticClass: "column " },
            [_c("upload", { ref: "upload", attrs: { isMultiple: true } })],
            1
          )
        ]),
        _c("div", { staticClass: "columns" }, [
          _vm._m(12),
          _c("div", { staticClass: "column " }, [
            _c("div", { staticClass: "control" }, [
              _c("label", { staticClass: "radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user.engineerService,
                      expression: "user.engineerService"
                    }
                  ],
                  attrs: { type: "radio", name: "answer", value: "Yes" },
                  domProps: {
                    checked: _vm._q(_vm.user.engineerService, "Yes")
                  },
                  on: {
                    change: function($event) {
                      _vm.$set(_vm.user, "engineerService", "Yes")
                    }
                  }
                }),
                _vm._v("\n              Yes\n            ")
              ]),
              _c("label", { staticClass: "radio" }, [
                _c("input", {
                  directives: [
                    {
                      name: "model",
                      rawName: "v-model",
                      value: _vm.user.engineerService,
                      expression: "user.engineerService"
                    }
                  ],
                  attrs: { type: "radio", name: "answer", value: "No" },
                  domProps: { checked: _vm._q(_vm.user.engineerService, "No") },
                  on: {
                    change: function($event) {
                      _vm.$set(_vm.user, "engineerService", "No")
                    }
                  }
                }),
                _vm._v("\n              No\n            ")
              ])
            ])
          ])
        ]),
        _c("div", { staticClass: "columns" }, [
          _c("div", { staticClass: "column is-3 is-hidden-mobile" }),
          _c(
            "div",
            { staticClass: "column" },
            [
              _c("p", { staticClass: "has-text-grey-light" }, [
                _vm._v("\n              * required field\n            ")
              ]),
              _c("br"),
              _c("isButton", {
                ref: "btnCreate",
                attrs: {
                  slot: "action",
                  showProgress: true,
                  progressLevel: _vm.progressLevel,
                  onClick: _vm.createProject,
                  state: "true",
                  title: "Submit"
                },
                slot: "action"
              })
            ],
            1
          )
        ])
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "columns" }, [
      _c("div", { staticClass: "column is-12 col-head" }, [
        _c("div", { staticClass: "content" }, [
          _c("h1", { staticClass: "title" }, [
            _c("i", { staticClass: "fa fa-file" }),
            _vm._v(" Create Project")
          ]),
          _c(
            "h2",
            {
              staticClass: "subtitle is-5",
              staticStyle: { "padding-left": "37px" }
            },
            [_vm._v("สร้างโปรเจ็ค")]
          )
        ]),
        _c("hr")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3" }, [
      _c("b", [_vm._v("Project Name : *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3 " }, [
      _c("b", [_vm._v("Part Name : *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3" }, [
      _c("b", [_vm._v("Part Number : *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3" }, [
      _c("b", [_vm._v("Type Of Product : *"), _c("br")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3" }, [
      _c("b", [_vm._v("Material : *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3" }, [
      _c("b", [_vm._v("Hardening :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3" }, [
      _c("b", [_vm._v("Plating :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3" }, [
      _c("b", [_vm._v("Quantity : *")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3" }, [
      _c("b", [_vm._v("Data Inspection"), _c("br"), _vm._v("/การตรวจสอบ :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3" }, [
      _c("b", [_vm._v("Description :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3" }, [
      _c("b", [_vm._v("Upload :")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "column is-3" }, [
      _c("b", [
        _vm._v("Engineer Service On Site"),
        _c("br"),
        _vm._v("/บริการตรวจสอบหน้างาน")
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-31591d43", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-31591d43","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/create-project.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-31591d43","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/create-project.vue
// module chunks = 13 14